export const DASHBOARD_ROOT = "/dash";
export const ROOT = "/";

export const DASHBOARD_ROUTES = {
  Profile: `${DASHBOARD_ROOT}/profile`,
  Payments: `${DASHBOARD_ROOT}/payments`,
  broadcastArea: `${DASHBOARD_ROOT}/broadcast`,
  arvutSystem: `${DASHBOARD_ROOT}/arvutsytem`,
  archive: `${DASHBOARD_ROOT}/archive`,
  membership: `${DASHBOARD_ROOT}/membership`,
  previousPayment: `${DASHBOARD_ROOT}/membership/payments`,
};
